/* eslint-disable import/no-default-export */
import { normalizeCard } from 'app/gamma/src/api/normalizers/card';
import {
  LOAD_BOARD_SUCCESS,
  LoadBoardSuccessAction,
} from 'app/gamma/src/modules/loaders/load-board';
import {
  LOAD_CARD_SUCCESS,
  LoadCardSuccessAction,
} from 'app/gamma/src/modules/loaders/load-card';
import { SOCKET_CARD, SocketCardAction } from 'app/gamma/src/modules/sockets';
import { CardModel } from 'app/gamma/src/types/models';
import { createReducer } from '@trello/redux';
import { uniqBy } from '@trello/arrays';
import { PERFORM_SEARCH_SUCCESS, PerformSearchSuccessAction } from './search';
import updateModelList from './util/updateModelList';

// Reducer
export type CardState = CardModel[];
const initialState: CardState = [];

export default createReducer(initialState, {
  [LOAD_BOARD_SUCCESS](state, { payload }: LoadBoardSuccessAction) {
    const { cards = [] } = payload;

    return uniqBy(
      cards.map((card) => normalizeCard(card)).concat(state),
      (card) => card.id,
    );
  },

  [LOAD_CARD_SUCCESS](state, { payload }: LoadCardSuccessAction) {
    const card = normalizeCard(payload);
    const existingCard = state.find((c) => c.id === card.id) || {};

    return state
      .filter((c) => c.id !== card.id)
      .concat([{ ...existingCard, ...card }]);
  },

  [SOCKET_CARD](state, { payload }: SocketCardAction) {
    return updateModelList(state, payload, normalizeCard);
  },

  [PERFORM_SEARCH_SUCCESS](state, { payload }: PerformSearchSuccessAction) {
    const { cards = [] } = payload;

    return cards.reduce((result, card) => {
      const idx = result.findIndex((c) => c.id === card.id);
      if (idx === -1) {
        return result.concat([normalizeCard(card)]);
      }
      result[idx] = { ...result[idx], ...normalizeCard(card) };

      return result;
    }, state);
  },
});
